export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST'
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS'
export const ADD_ADDRESS_FALIURE = 'ADD_ADDRESS_FALIURE'
